import { memo } from 'react';
import { Fill } from 'react-slot-fill';
import { BehaviorSubject } from 'rxjs';
import { HoldZone } from '../functions/holdZone';
import { SpokenVoice, VoiceTurn } from '../functions/useVoiceTurn';
import { VoiceEditor } from '../hold-overlay/VoiceEditor';
import { VoiceHoldOverlay } from '../hold-overlay/VoiceHoldOverlay';

/**
 * What a hold puts over the app: its words and where letting go takes them
 * (the overlay, from the root's portal: it never takes a touch), and the
 * editor for words let go of on 编辑.
 */
export const VoiceHoldLayers = memo(
  ({
    voice,
    zone$,
    editing,
    canSend,
    onSendEdited,
    onCloseEditor,
  }: {
    voice: VoiceTurn;
    zone$: BehaviorSubject<HoldZone>;
    editing: { text: string; voice: SpokenVoice } | null;
    canSend: boolean;
    onSendEdited: (text: string, voice: SpokenVoice) => void;
    onCloseEditor: () => void;
  }) => (
    <>
      <VoiceEditor
        text={editing?.text ?? null}
        canSend={canSend}
        onSend={line => {
          if (editing) onSendEdited(line, editing.voice);
          onCloseEditor();
        }}
        onClose={onCloseEditor}
      />
      <Fill name="portal">
        <VoiceHoldOverlay
          state$={voice.state$}
          level$={voice.level$}
          zone$={zone$}
        />
      </Fill>
    </>
  ),
);
